import { makeStyles } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    headerCell: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        userSelect: 'none',
    },
    popoverTrigger: {
        display: 'flex',
    },
    popoverSurface: {
        padding: px(0),
    },
});
